import styled from 'styled-components';
import colors from '../../../../lib/Colors';

const PlacesAutocompleteFragment = styled.div`
  .ac-container {
    position: absolute;
    top: 100%;
    background-color: white;
    border: 1px solid #555555;
    width: 100%;
    z-index: 1000;
  }
  
  & input {
      /*background-image: url("../../../../../../assets/svgs/search.svg");
      background-size: 17px 17px;
      background-repeat: no-repeat;
      background-position: 10px 1rem;*/
      border: none;
      width: 100%;
      background-color: ${colors.white};
      font-size: 16px;
      padding: 20px 15px 5px 5px;
      border-radius: 3px 3px 0 0;
      transition: border-bottom 0.3s ease-in-out;
      border-bottom: solid 1px ${colors.blue} !important; 
      box-sizing: border-box;
      color: ${colors.black};
        &:focus {
      border: solid 1px ${colors.blue} !important;
      outline: none;
    }
  }
    height: 42px;
    border: 1px solid transparent !important;
    width: 100% !important;
    color: ${colors.almostBlack} !important;
`;

const OptionFragment = styled.div`
  background-color: ${colors.white};
  &:hover {
    background-color: ${colors.blue}
  };
  z-index: 1000;
  position: relative;
  padding: 5px;
`;

export {PlacesAutocompleteFragment, OptionFragment};
